<template>
    <div>
        <v-toolbar dense color="accent" class="elevation-4" style="margin: 10px 10px 15px;">
            <v-toolbar-title>
                <!-- img style="height: 56px; margin-top: 9px;" src="../../assets/simomics.svg"-->
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon color="#000000DE" @click="reset()">
                <v-icon>
                    mdi-refresh
                </v-icon>
            </v-btn>

            <v-btn icon color="white" @click="dialogHelp = true" style="text-transform: capitalize; font-size: 13px;">
                <v-icon>
                    mdi-information
                </v-icon>
            </v-btn>

            <helpDialog v-model="dialogHelp">
            </helpDialog>
        </v-toolbar>

        <v-card class="elevation-4" style="margin: 0 10px; padding-top: 20px;">

            <v-layout wrap>

                <v-flex xs12>
                    <selectorMobile :filter="filters.substances" :sortItemsCaseInsensitive="true" label="Substances" first>
                    </selectorMobile>
                </v-flex>

                <v-flex xs12>
                    <selectorMobile :filter="filters.goals" label="Protection Goals" :multiple="false">
                    </selectorMobile>
                </v-flex>

                <v-flex xs12>
                    <selectorMobile :filter="filters.compartments" label="Environmental Compartments">
                    </selectorMobile>
                </v-flex>

                <v-flex xs12>
                    <selectorMobile :filter="filters.locations" label="Regions" autocomplete>
                    </selectorMobile>
                </v-flex>

                <v-flex xs12>
                    <selectorMobile :filter="filters.detects" label="RQ" :multiple="false" last
                        @click="filters.detects.toggle">
                    </selectorMobile>
                </v-flex>

            </v-layout>
        </v-card>
    </div>
</template>

<script>
    import { Filters } from '../../ts/filters'
    import selectorMobile from './selectorMobile.vue'
    import helpDialog from '../selectors/dialogs/helpDialog.vue'

    export default {
        components: {
            selectorMobile,
            helpDialog,
        },
        props: {
            filters: {
                required: true,
                type: Filters
            },
        },
        data() {
            return {
                dialogHelp: false,
            }
        },
        methods: {
            reset() {
                this.filters.selectAll()
                this.$emit('resetAll')
            }
        }
    }
</script>

<style scoped>
    .navbuttons {
        text-transform: capitalize;
        font-weight: normal;
        font-size: 13px;
    }
</style>
